import { render } from "./App.vue?vue&type=template&id=7687759a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/styles/variables.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__